import ClientAPI from '../ClientAPI'

const clientAPI = new ClientAPI()

const getSubstitutes = async (requestData) => clientAPI.getSubstituteProducts(requestData)

export default getSubstitutes
